import React, { useReducer, useState } from 'react';
import { initialState, AuthReducer } from './reducer';
import moment from 'moment/moment';

const AuthStateContext = React.createContext();
const AuthDispatchContext = React.createContext();
const FinancialContext = React.createContext();
const MonthContext = React.createContext();


export function useAuthState() {
	const context = React.useContext(AuthStateContext);
	if (context === undefined) {
		throw new Error('useAuthState must be used within a AuthProvider');
	}
	return context;
}

export function useAuthDispatch() {
	const context = React.useContext(AuthDispatchContext);
	if (context === undefined) {
		throw new Error('useAuthDispatch must be used within a AuthProvider');
	}

	return context;
}

export function useFinancial() {
	const context = React.useContext(FinancialContext);
	if (context === undefined) {
		throw new Error('useMonth must be used within a MonthProvider');
	}
	return context;
}

export function useMonth() {
	const context = React.useContext(MonthContext);
	if (context === undefined) {
		throw new Error('useMonth must be used within a MonthProvider');
	}
	return context;
}

export const AuthProvider = ({ children }) => {

	const CurrentYear = moment().format('YYYY')

	const CurrentMonth = moment().format('M')

	const [year, setYear] = useState({
		DDL: [],
		ID: 0,
		Label: "Year .....",
	})
	const [Month, setMonth] = useState({
		DDL: [],
		ID: 0,
		Label: "Month .....",
	})

	const [user, dispatch] = useReducer(AuthReducer, initialState);

	return (
		<AuthStateContext.Provider value={{ user, year, setYear, Month, setMonth, CurrentYear, CurrentMonth }}>
			<AuthDispatchContext.Provider value={dispatch}>
				{children}
			</AuthDispatchContext.Provider>
		</AuthStateContext.Provider>
	);
};



